<template>
  <div class="sale" v-loading="loading">
    <div class="sale-first">
      <div class="sale-first-top">
        <div class="sale-first-top-title">用户保证金提取信息</div>
      </div>
      <div class="sale-first-center">
        <div
          class="sale-first-center-list"
          v-for="(item, index) in 9"
          :key="index"
        >
          <div class="sale-first-center-list-title">
            {{
              index == 0
                ? '用户id'
                : index == 1
                ? '用户姓名'
                : index == 2
                ? '用户手机号'
                : index == 3
                ? '订单号'
                : index == 4
                ? '订单类型'
                : index == 5
                ? '支付方式'
                : index == 6
                ? '支付订单号'
                : index == 7
                ? '支付时间'
                : index == 8
                ? '申请时间'
                : ''
            }}
          </div>
          <div class="sale-first-center-list-text">
            {{
              index == 0
                ? paymentObj.userId
                : index == 1
                ? paymentObj.realname
                : index == 2
                ? paymentObj.phone
                : index == 3
                ? paymentObj.orderNum
                : index == 4
                ? paymentObj.status == 0
                  ? '待支付'
                  : paymentObj.status == 1
                  ? '已支付'
                  : paymentObj.status == 2
                  ? '退款中'
                  : paymentObj.status == 3
                  ? '退款失败'
                  : paymentObj.status == 4
                  ? '退款未通过'
                  : paymentObj.status == 5
                  ? '退款申请中'
                  : paymentObj.status == 6
                  ? '已退款'
                  : ''
                : index == 5
                ? paymentObj.payType == 0
                  ? '银行卡'
                  : paymentObj.payType == 1
                  ? '微信'
                  : paymentObj.payType == 2
                  ? '支付宝'
                  : paymentObj.payType == 5
                  ? '银盛微信'
                  : paymentObj.payType == 6
                  ? '银盛支付宝'
                  : paymentObj.payType == 7
                  ? '银盛网银'
                  : ''
                : index == 6
                ? afterRefundObj.orderNum
                : index == 7
                ? afterRefundObj.endTime
                : index == 8
                ? paymentObj.createTime
                : ''
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="sale-thirdly">
      <div class="sale-thirdly-top">申请提取保证金信息</div>

      <div class="sale-thirdly-center">
        <div
          class="sale-thirdly-center-list"
          v-for="(item, index) in 3"
          :key="index"
        >
          <div class="sale-thirdly-center-list-title">
            {{
              index == 0
                ? '用户累计缴纳保证金'
                : index == 1
                ? '用户提取保证金'
                : '申请时间'
            }}
          </div>
          <div class="sale-thirdly-center-list-text">
            {{
              index == 0
                ? afterRefundObj.money
                : index == 1
                ? paymentObj.money
                : afterRefundObj.createTime
            }}
            <div class="price" v-if="index != 2">元</div>
          </div>
        </div>

        <div class="sale-thirdly-center-list">
          <div class="sale-thirdly-center-list-title">用户保证金缴纳时间</div>
          <div class="sale-thirdly-center-list-text" style="cursor: pointer">
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                afterRefundObj.hyear == 0
                  ? '截止到目前为止，当前用户缴纳保证金时的时间未超过6个月'
                  : afterRefundObj.hyear == 1
                  ? '截止到目前为止，当前用户缴纳保证金时的时间已超过6个月'
                  : ''
              "
              placement="top-start"
            >
              <el-tag
                class="tag-title"
                :type="
                  afterRefundObj.hyear == 0
                    ? 'success'
                    : afterRefundObj.hyear == 1
                    ? 'danger'
                    : ''
                "
              >
                {{
                  afterRefundObj.hyear == 0
                    ? '未超过6个月'
                    : afterRefundObj.hyear == 1
                    ? '已超过6个月'
                    : ''
                }}
              </el-tag>
            </el-tooltip>
          </div>
        </div>

        <div class="sale-thirdly-center-list">
          <div class="sale-thirdly-center-list-title">是否需要手动打款</div>
          <div class="sale-thirdly-center-list-text">
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                paymentObj.manually == 0
                  ? '截止到目前，当前用户缴纳保证金时的时间未超过6个月，原路退回'
                  : paymentObj.manually == 1
                  ? '截止到目前，当前用户缴纳保证金时的时间已超过6个月，手动打款'
                  : ''
              "
              placement="top-start"
            >
              <el-tag
                class="tag-title"
                :type="
                  paymentObj.manually == 0
                    ? 'success'
                    : paymentObj.manually == 1
                    ? 'danger'
                    : ''
                "
              >
                {{
                  paymentObj.manually == 0
                    ? '原路退回'
                    : paymentObj.manually == 1
                    ? '手动打款'
                    : ''
                }}
              </el-tag>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="sale-thirdly-amount">
        <div class="sale-thirdly-amount-title">拒绝理由</div>
        <div class="sale-thirdly-amount-input">
          <el-input
            v-model="afterRefundamount"
            placeholder="请输入拒绝理由"
            class="inputmoneys"
            type="textarea"
            clearable
          ></el-input>
        </div>
      </div>

      <div class="sale-thirdly-bottom">
        <div class="sale-thirdly-bottom-left" @click="refuseFefund">
          拒绝退款
        </div>
        <div class="sale-thirdly-bottom-right" @click="consentFefund">
          同意退款
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'
import { getEarnetInfo, postUpdateEarnety } from '../../api/partenr'

var throttle = require('../../utils/throttle')

export default {
  data() {
    return {
      afterRefundamount: '',
      loading: false,
      afterRefundObj: {},
      paymentObj: {},
      audit1Status: '',
      audit1Options: [
        {
          label: 'PASS',
          title: '同意',
        },
        {
          label: 'REFUSE',
          title: '拒绝',
        },
        {
          label: 'UNDEFINED',
          title: '未处理',
        },
      ],
    }
  },
  created() {
    this.loading = true

    console.log(
      '-----------------------------------------------------------------详情'
    )

    // 获取status等于-1  取钱
    this.getEarnetInfoClick()

    // 获取缴纳的时候
    this.getEarnetInfoMet()
  },
  mounted() {},
  updated() {
    if (this.$route.query.userId == undefined) {
      Bus.$emit('detele', 'auditcashextractPartnerdetails')
    }
  },
  methods: {
    aaaaaback() {
      this.$router.push({ name: 'auditcashextractPartner' })
      Bus.$emit('detele', 'auditcashextractPartnerdetails')
    },

    // 获取保证金缴纳的时候
    getEarnetInfoMet() {
      let params = {
        id: this.$route.query.withdrawid,
        pageSize: 100000,
        pageNo: 1,
        type: 0, //
        userId: '',
        phone: '',
        name: '',
        status: '', //
        payType: '',

        withdrawStatus: '', // 状态
        payCode: '',
        createStartTime: '',
        createEndTime: '',
      }

      getEarnetInfo(params).then((res) => {
        if (res.resultStatus == true) {
          this.afterRefundObj = res.resultData.list[0]
          this.loading = false
        }
      })
    },

    refuseFefund() {
      if (this.paymentObj.withdrawStatus != 'UNDEFINED') {
        this.$message.error('当前记录已被审核操作')
        return
      }

      this.cashextactMet('REFUSE')
    },
    consentFefund() {
      if (this.paymentObj.withdrawStatus != 'UNDEFINED') {
        this.$message.error('当前记录已被审核操作')
        return
      }

      this.cashextactMet('PASS')
    },

    cashextactMet: throttle.throttle(function (item) {
      let params = {
        id: this.paymentObj.id,
        withdrawStatus: item,
        reason: this.afterRefundamount,
      }

      console.log('退款', params)

      postUpdateEarnety(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message.success(
            item == 'REFUSE' ? '拒绝退款成功！' : '同意退款成功！'
          )
          this.$router.push({ name: 'auditcashextractPartner' })
          Bus.$emit('detele', 'auditcashextractPartnerdetails')
        }
      })
    }, 3000),

    // 取钱
    getEarnetInfoClick() {
      let params = {
        userId: this.$route.query.userId,
        type: -1, // 取钱
        pageSize: 10000,
        pageNo: 1,
        phone: '',
        id: '',
        name: '',
        status: '', //
        payType: '',
        withdrawStatus: '', // 状态
        payCode: '',
        createStartTime: '',
        createEndTime: '',
      }

      getEarnetInfo(params).then((res) => {
        if (res.resultStatus == true) {
          res.resultData.list.forEach((item, index) => {
            if (item.id == this.$route.query.id) {
              this.paymentObj = item
              this.audit1Status = item.withdrawStatus
              this.loading = false
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.sale {
  .sale-first {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 24px;
    box-sizing: border-box;

    .sale-first-top {
      .sale-first-top-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }
    }

    .sale-first-center {
      margin-top: 29px;
      display: flex;
      flex-wrap: wrap;

      .sale-first-center-list {
        width: 280px;
        margin-right: 34px;
        margin-bottom: 25px;

        .sale-first-center-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .sale-first-center-list-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          margin-top: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;

          img {
            width: 17px;
            height: 17px;
            margin-left: 5px;
          }
        }
      }

      .sale-first-center-list:last-child {
        width: 400px;
        margin-right: 0;
      }
    }

    .sale-first-bottom {
      width: 88px;
      height: 36px;
      border-radius: 10px;
      border: 1px solid #36c100;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #36c100;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }
  }

  .sale-thirdly {
    padding: 24px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;

    .sale-thirdly-top {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #222222;
      margin-bottom: 27px;
    }

    .sale-thirdly-center {
      display: flex;

      .sale-thirdly-center-list {
        width: 160px;
        margin-right: 34px;

        .sale-thirdly-center-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #505050;
        }

        .sale-thirdly-center-list-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-top: 8px;
          display: flex;
          align-items: center;

          .tag-title {
            font-size: 14px;
          }

          .price {
            margin-left: 5px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
      }

      .sale-thirdly-center-list:last-child {
        margin-right: 0;
        width: 200px;
      }
    }

    .sale-thirdly-amount {
      margin-top: 22px;

      .sale-thirdly-amount-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
      }

      .sale-thirdly-amount-input {
        margin-top: 4px;
        width: 400px;
        height: 200px;

        /deep/ .el-input {
          height: 200px;
        }

        /deep/ .el-input__inner {
          padding: 0 10px;
          box-sizing: border-box;
          height: 100px;
          background-color: rgba(255, 255, 255, 0);
        }

        /deep/ .el-textarea__inner {
          height: 200px !important;
          resize: none;
        }
      }

      .sale-thirdly-amount-img {
        width: 64px;
        height: 64px;
        border-radius: 5px;
        margin-top: 4px;
        margin-right: 17px;
      }
    }

    .sale-thirdly-bottom {
      display: flex;
      margin-top: 25px;

      .sale-thirdly-bottom-left,
      .sale-thirdly-bottom-right {
        width: 88px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .sale-thirdly-bottom-right {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        color: #ffffff;
        margin-left: 24px;
        border: 0px solid rgba(0, 0, 0, 0.15);
      }
    }

    .sale-thirdly-negotiate {
      margin-top: 30px;

      .sale-thirdly-negotiate-block {
        padding: 25px 0;
        box-sizing: border-box;
        border-top: 1px solid #e9edf4;
        position: relative;

        .sale-thirdly-negotiate-div {
          display: flex;

          .sale-thirdly-negotiate-div-list {
            width: 160px;
            margin-right: 34px;

            .sale-thirdly-negotiate-div-list-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
            }

            .sale-thirdly-negotiate-div-list-text {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              margin-top: 8px;
            }

            .sale-thirdly-negotiate-div-list-img {
              width: 64px;
              height: 64px;
              border-radius: 5px;
              margin-right: 16px;
            }
          }

          .sale-thirdly-negotiate-div-position {
            position: absolute;
            width: 100px;
            height: 100px;
            right: 100px;
            display: flex;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
